/**
 * SelectAllClearToggles — "Select all / Clear" shortcuts for a checkbox list.
 *
 * Page-agnostic (own `sac-` classes, no rp-/ap- prefix) because the same control
 * is used by the residents drawers and the areas drawers. Each button disables
 * when it would be a no-op, which also communicates the current state.
 *
 * Pair with the `sac-field-header` wrapper to sit the control on the same line
 * as the field label:
 *
 *   <div className="sac-field-header">
 *     <p className="rp-field__label">Groups</p>
 *     <SelectAllClearToggles … />
 *   </div>
 *
 * @param {{
 *   onSelectAll: () => void,
 *   onClear: () => void,
 *   allSelected: boolean,
 *   noneSelected: boolean,
 * }} props
 */

import './select-all-clear-toggles.css';

const SelectAllClearToggles = ({ onSelectAll, onClear, allSelected, noneSelected }) => (
  <span className="sac-actions">
    <button
      type="button"
      className="sac-action"
      onClick={onSelectAll}
      disabled={allSelected}
    >
      Select all
    </button>
    <span className="sac-sep" aria-hidden="true">·</span>
    <button
      type="button"
      className="sac-action"
      onClick={onClear}
      disabled={noneSelected}
    >
      Clear
    </button>
  </span>
);

export default SelectAllClearToggles;
